import React, {useEffect, useState, useDeferredValue} from 'react';
import {
  Grid, Stack, 
  TextField, IconButton, Tooltip, InputAdornment,
  Paper, Typography, Autocomplete, Box,
  Button, MenuItem, InputLabel,Select, FormControl, 
} from '@mui/material';


import { useSelector,useDispatch } from 'react-redux';
import {  
  selectAllVipHostIds,
  selectAllVipHosts,
  selectVipHostById,
  fetchAllVipHosts,
  createVipHost,
  updateVipHost,
  deleteVipHost,
  selectVipHostIdsByFilter,
}  from '../../store/vipHostSlice'

import DeleteIcon from '@mui/icons-material/DeleteForever';
import EditIcon from '@mui/icons-material/AutoFixHigh';


import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';

import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import { regxCountyCode, regxPhoneNumber } from '../../utils/ValidationConst';

import { format, set } from 'date-fns';

import {useAppAuthContext} from '../../utils/AppAuthContext'

import {usePlayContext} from '../../utils/PlayContext';

import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';


import {regexEmail, regxPhone, regxLocalPhone, localPhoneError, phoneHelpText} from '../../utils/ValidationConst'


import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';

import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Dialog from '@mui/material/Dialog';
import { KeyTwoTone } from '@mui/icons-material';



const VipHostDialog = (props) => {
  const {
    op, setOp, setStatus, setErrorMessage,
    nid, setNid,
   openSnackToast
  }=usePlayContext()

  const dispatch = useDispatch()
  const [email, setEmail] = useState(nid?.email)
  const [emailError, setEmailError] = useState('')
  const [phoneNumber, setPhoneNumber] = React.useState(nid?.phoneNumber)
  const [phoneNumberError, setPhoneNumberError] = React.useState('');

  const [description, setDescription] = useState(nid?.description)
  const [descriptionError, setDescriptionError] = useState('')

  const allVipHosts = useSelector(selectAllVipHosts)

  const isPhoneNumberValid=Boolean(phoneNumber) && phoneNumber.match(regxPhoneNumber) 
 //const isCountryCodeValid = !Boolean(countryCode) || countryCodeError.match(regxCountyCode)
 
  let myttile = '', mylabel='', mysize='lg'

  if (op==='add'){
    myttile = mylabel = 'Create'
  } 
  else    if (op==='edit'){
    myttile = 'Edit'
    mylabel='Update'
  } 
  else if (op==='delete')
  {
    myttile = mylabel = 'Delete'

  }

    const doDelete= async(id)=>
    {
        setStatus('loading')
        try
        {
            let xx = dispatch(deleteVipHost(id)).unwrap();
            setStatus('idle')
        }
        catch (ex)
        {
            console.error(ex)
            setErrorMessage("Error during deletion")
            setStatus('error')
        }

        setOp('')
        setNid(null)

    }
  
    const doCommit=async()=>
    {
      if ('delete'==op)
      {
          await doDelete(nid.id);     
          return;
      }

      let errNo=0

      if (!Boolean(email) || !Boolean(email.trim()))
      {
          setEmailError('Email cannot be empty')
          errNo++;
      }
      else if (!email.match(regexEmail))
      {
        setEmailError('Email is invalid')
        errNo++;
      }
      else setEmailError('')

      if ( description && description.length>40)
      {
        setDescriptionError('Description cannot exceed 40 letters')
        errNo++;
      }
      else  setDescriptionError('')

     
      if (!Boolean(phoneNumber))
      {
        errNo++
        setPhoneNumberError('Phone Number is required')
      }
      else if (!isPhoneNumberValid)
      {
          errNo++
          setPhoneNumberError('Phone Number invalid')
      }
      else setPhoneNumberError('')
      if (errNo>0) return
      

      
      let phoneDisplay
      
      phoneDisplay = '+65-'+phoneNumber;
      
      if (errNo>0) return

      let email1=email.toLowerCase()
      let xx = allVipHosts.find(x=> x.email.toLowerCase()===email1)
      if (xx)
      {
          if (op==='add')
          {
              setEmailError('Email already exists')
              errNo++
          }
          else
          {
              if (xx.id!==nid.id)
              {
                setEmailError('Email already exists')
                errNo++
              }
          }
      }
      else      setEmailError('')
      setDescriptionError('')
      

      if (errNo>0) return

	    setStatus('idle')
      try
      {

          if (op==='add')
          {
              await dispatch(createVipHost({
					email:email1,
          phone:phoneNumber,
					description,
					})).unwrap();
          }
          else
          {
            await dispatch(updateVipHost(
              {
                email:email1,
                phone:phoneNumber,
				        description,
                id:nid.id
              })
              
              ).unwrap();
          }
          setStatus('idle')

          
        }
        catch (ex)
        {
            console.error(ex)
            setErrorMessage("Error during vipHost "+ (op==='add'? 'creation':'update'));
            setStatus('error')
        }

        setOp('')
        setNid(null)

    }
  return (
    <Dialog 
        open={Boolean(op)}
        
        maxWidth={mysize}
        onClose={e => setOp('')}>
      <DialogTitle sx={{}}><small>{myttile}&nbsp;VIP HOST</small></DialogTitle>
      <DialogContent>
        <Box sx={{p:1, mx:1, border:0, borderColor:'#999999', borderRadius:3, maxWidth:900, minWidth:600}}>

          {
            op==='delete' &&
              <Typography variant='h6' textAlign='center' sx={{color:'primary.main'}}>
                Are you sure to delete the item?
                </Typography>
          }
          {
            (op==='edit' || op==='add') &&
            <Stack spacing={2}>
              <TextField 
                size='small'
                required
                fullWidth
                error={Boolean(emailError)}
                value={email}
                id="id_dig_email" label="Email" type="text" 
                onChange = { e=>setEmail(e.target.value)}
                inputProps={{ maxLength: 40,  }}
                helperText={ emailError}/>

            <TextField 
                size='small'
                required
                sx={{width:'50%'}}
                type='number'
                error={Boolean(phoneNumberError)}
                value={phoneNumber}
                id="id_dig_phonenum" 
                label="Phone Number" 
                onChange = { e=>setPhoneNumber(e.target.value)}
                inputProps={{ maxLength: 20,  }}
                InputProps={{
                  startAdornment: <InputAdornment position="start"><strong>+65-</strong></InputAdornment>,
                }} 
                helperText={ phoneNumberError}
                />
      
              <TextField 
                size='small'
                //required
                fullWidth
                error={Boolean(descriptionError)}
                value={description}
                id="id_description" 
                label="Description" 
                type="text" 
                onChange = { e=>setDescription(e.target.value)}
                inputProps={{ maxLength: 40  }}
                helperText={ descriptionError}/>
        </Stack>
          }
          </Box>
      </DialogContent>
         
      <DialogActions sx={{m:0,pb:2}}>
        <Box sx={{display:'flex', justifyContent:'space-around', width:'88%'}}>
            <Button variant="outlined" autoFocus size='small' color='success'
                onClick={doCommit}
                disabled={!Boolean(email) || !Boolean(email.trim())}
                >
                {mylabel}
            </Button>
            <Button variant="outlined"
                onClick={e=>{setNid(null); setOp("")}}
                color='success' 
                size='small'>
              Cancel
            </Button>
        </Box>
      </DialogActions>
     </Dialog>
  );
};


const VipHostTableHeader=()=>{

  return (
        <TableHead>
                <TableRow sx={{bgcolor:'#98DDFF'}}>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600, width:'25%'}}>Email</TableCell>
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600, width:'15%'}}>Phone</TableCell>
                    
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600, width:'40%'}}>Description</TableCell>
                    
                    <TableCell align="center" style={{border: '1px solid LightGray', fontWeight: 600}}>ACTIONS</TableCell>
                    
                  </TableRow>
      </TableHead>

  )
}

const VipHostTableRow=({id, index})=>
{
    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {
      op, setOp,
      nid, setNid,
     openSnackToast
    }=usePlayContext()
    const row = useSelector(  selectVipHostById(id))


    const deteteRow= ()=>{
        if (id && row)
        {
          setNid(row)
          setOp('delete')
        }
    }
    const editRow =()=>{
      if (id && row)
      {
        setNid(row)
        setOp('edit')
  
      }

    }


    return(
      <TableRow>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
            {row.email}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
            {row.phoneDisplay}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
            {row.description}
        </TableCell>
        <TableCell  style={{border: '1px solid LightGray', whiteSpace:'nowrap'}}>
            <Box sx={{display:'flex', justifyContent:'space-around', flexDirection:'row', m:0, p:0}} >
              <IconButton size='small' color='primary'
                  onClick={editRow}
                  >
                  <EditIcon size='small'/>
              </IconButton>
              <IconButton size='small' color='primary'
                onClick={deteteRow}
              ><DeleteIcon size='small'/></IconButton>
            </Box>
        </TableCell>
  </TableRow>

    )


}



const VipHostPage = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const {userInfo, managedHosts} = useAppAuthContext()
  
    const {
      op, setOp,
      nid, setNid,
      status, setStatus, setAppTitle, 
      setErrorMessage,  setErrorTitle,
      setTenantLogo, openSnackToast
    }=usePlayContext()


    const [keyword, setKeyword]=useState('');
  
    const deferredKeyword  = useDeferredValue(keyword)

    //const allReasonIds = useSelector(state=>selectVipHostIdsByFilter(state, keyword))
    const allReasonIds = useSelector(state=>selectVipHostIdsByFilter(state, deferredKeyword))
  
    const addReason = ()=>{
      setOp('add')
          
      setNid(null)
        //alert(123)

    } 


    const doFetchVipHostList = async ()=>
    {
      
        console.log("doFetchVipHostList")
        setStatus('processing')
        try
        {
          let respAlldoFetchVipHosts = await dispatch(fetchAllVipHosts()).unwrap();
            setStatus('idle')
        }
      catch (ex)
      {
        console.error(ex)
        setStatus('error')
        setErrorMessage("Cannot retrieve Vip Host  info")
      } 
    }

    

    useEffect(() => {
      setAppTitle(  ['Administration','VIP Hosts', ])
      setErrorMessage('')
      setErrorTitle('')

      setOp('')
      setNid(null)
      doFetchVipHostList()
      return () => {

      }

    }, [])

  return (
    <Box sx={{p:1}}>
        <Card sx={{width:'100%',  pt:2, mb:1, pb:0}} raised>
            
        <CardContent sx={{my:0, py:1}}>
        <Grid
          container 
          spacing={1}
          direction={'row'}
          columns={12}
        >
       
             <Grid item xs={12} sm={6}  md={4} >
              <Autocomplete 
                fullWidth
                size='small'
                freeSolo
                selectOnFocus
                handleHomeEndKeys
                //disableClearable
                id="id_key_word_email" 
                value={keyword}
                onInputChange={(e,n)=>setKeyword(n)}
                options={[]} 
                renderInput={(params) => 
                    <TextField {...params} 
                      //onChange = { e=>{setKeyword(e.target.value);}}
                      label="Search by Phone or Email"  
                      />}
                />
              </Grid>
            <Grid item xs={12} sm={6} md={8} sx={{  }}>
              <Box sx={{mt:1,display:'flex', width:'100%', justifyContent: 'space-between'}}>

                  <Button variant="outlined"  color='info'  
                    onClick={e=>setKeyword('')}
                  > Clear</Button>

                  <Button variant="outlined"  color='primary'  
                    onClick={addReason}
                  > Add</Button>
              </Box>
          </Grid>                          
        </Grid>

        </CardContent>
        </Card>
          <TableContainer component={Paper} >
            <Table  size='small' >
              <VipHostTableHeader/>
                <TableBody>
                  { allReasonIds && allReasonIds.length>0 &&
                      allReasonIds.map((id, i)=>

                        <VipHostTableRow key={id} id={id}/> 
                      )
                  }
              </TableBody>
            </Table>
        </TableContainer>
        
        {Boolean(op)&& 
        <VipHostDialog />
        }
      </Box>
  );
};


export default VipHostPage;
